// Returns a negated version of the passed-in predicate.
export default function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/negate.js
// module id = 195
// module chunks = 0